export class RedirectStrategy {
  id;
  clientId;
  name;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/redirect-strategies/redirect-strategy.model.ts